import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '../../../core/i18n';
import type { ActiveMaintenanceBanner } from '../shell-hero/app-config.model';

/** Dismissible S3-configured maintenance notice using the established blue alert treatment. */
@Component({
  selector: 'app-shell-system-alert',
  imports: [TranslatePipe],
  templateUrl: './shell-system-alert.html',
  styleUrl: './shell-system-alert.scss',
})
export class ShellSystemAlert {
  readonly visible = input.required<boolean>();
  readonly banner = input.required<ActiveMaintenanceBanner>();
  readonly dismissed = output<void>();
}
